import React, { useEffect, useState } from "react";
import "@cyntler/react-doc-viewer/dist/index.css";
import "./PdfOpener.css";
import { validateRemoteFile } from "../../Utils/helper";
import CorruptedFileMessage from "../CorruptedFileMessage";
import FileViewer from 'react-file-viewer';
import CustomPdfViewer from "./CustomPdfViewer";

// skipIntegrityCheck: DocumentRenderer already validated this URL.
const PdfOpener = ({ path = "", type, skipIntegrityCheck = false }) => {
  const [integrity, setIntegrity] = useState({
    status: skipIntegrityCheck || !path ? "ok" : "checking",
    message: "",
  });

  useEffect(() => {
    let cancelled = false;

    // Direct PdfOpener usages (without DocumentRenderer) still need a check.
    if (skipIntegrityCheck || !path) {
      setIntegrity({ status: "ok", message: "" });
      return;
    }

    const checkFile = async () => {
      setIntegrity({ status: "checking", message: "" });
      const result = await validateRemoteFile(path, `file.${type || "pdf"}`);
      if (cancelled) return;
      if (!result.valid) {
        setIntegrity({ status: "error", message: result.message });
        return;
      }
      setIntegrity({ status: "ok", message: "" });
    };

    checkFile();
    return () => {
      cancelled = true;
    };
  }, [path, type, skipIntegrityCheck]);

  if (!path) return null;

  if (integrity.status === "checking") {
    return <CorruptedFileMessage message="Checking file..." />;
  }

  if (integrity.status === "error") {
    return <CorruptedFileMessage message={integrity.message} />;
  }
 const docs = [{ uri: path }];

  return (
  <div style={{ width: "100%", height: "calc(100vh - 20px)", padding: "10px", overflow: "auto"}}>
    {type === "pdf" ? (
      <CustomPdfViewer path={path} />
    ) : (
      <FileViewer fileType={type} filePath={path} />
    )}
  </div>
);
};
export default PdfOpener;
